import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getLatestActiveProjectsOfUser = async (
  { activeEmployerInfo = {}, isLocalApiRequest = false } = {}
) => {
  const apiPath = `user/projects/record-activity-project-ids-last-30-days`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
